import { GrDocumentDownload } from "react-icons/gr";
import styled from "styled-components";

export const Container = styled.div`
  padding: 64px;
  min-height: 100%;
  background-color: var(--ghost);

  @media only screen and (max-device-width: 812px) {
    padding: 0 0 24px;
    background-color: var(--white);
  }
`;

export const Content = styled.div`
  width: 100%;
  padding: 48px;
  margin: 0 auto;
  border-radius: 8px;
  background-color: var(--white);
  box-shadow: 0px 4px 8px 0px #e0e0e0;

  .ant-btn {
    height: 48px !important;
  }

  .send-icon {
    fill: none !important;
    stroke: var(--dark-2);
  }

  .btn-filter {
    border-radius: 24px;
    font-weight: 500 !important;
    svg {
      stroke: var(--ant-primary-color);
    }
    &.filtro-aplicado {
      color: var(--ant-primary-color);
      border: 1px solid var(--ant-primary-color);
      background-color: var(--ant-primary-1);
    }
  }
  .downloadSheet {
    font-weight: 500 !important;
    svg {
      fill: var(--ant-primary-color);
    }
  }

  .button-disabled-plan {
    position: relative;

    .over-button-disabled {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      z-index: 999;
    }
  }

  .calc-status {
    display: flex;
    align-items: center;
    justify-content: center;
    column-gap: 6px;
    span {
      width: 8px;
      height: 8px;
      min-width: 8px;
      min-height: 8px;
      border-radius: 4px;
      display: inline-block;
      background-color: var(--red);
      &.Regular {
        background-color: var(--green-1);
      }
      &.NOT_PAYED {
        background-color: var(--yellow);
      }
    }
  }

  .ant-btn-group.ant-dropdown-button {
    .ant-btn {
      text-transform: none;
      border-color: var(--dark-1);
      :first-of-type {
        border-radius: 24px;
        margin-right: 8px;
      }
      :last-of-type {
        border-radius: 24px;
      }
      :disabled,
      :hover {
        color: var(--gray-1);
        border-color: var(--gray-1);
      }
      &.ant-dropdown-trigger {
        svg {
          fill: var(--dark-1);
        }
        :disabled,
        :hover {
          svg {
            fill: var(--gray-1);
          }
        }
      }
    }
  }

  .ant-list.ant-list-split {
    padding: 0 32px;
    border: 2px solid var(--dark-1);
    border-radius: 8px;
    .ant-list-item-action > li {
      padding: 0;
    }
  }
  .ant-list-item {
    padding: 20px 0;
  }
  .ant-list-item-meta-title {
    font-size: 1rem;
    font-weight: 700;
  }
  .ant-list-item-action > li,
  .ant-list-item-meta-title,
  .ant-list-item-meta-description {
    color: var(--white);
  }
  .ant-list-item-action {
    display: flex;
    row-gap: 4px;
    column-gap: 8px;

    .ant-btn.hire-btn {
      color: var(--ant-primary-color) !important;
      border-color: var(--dark-1);
      background-color: var(--dark-1);
    }

    .ant-btn.action-btn {
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: space-between;
      row-gap: 0;
      height: 48px;
      padding: 0 4px;
      font-size: 14px;
      color: var(--white);

      svg,
      svg * {
        stroke: var(--ant-primary-color);
      }
    }
  }

  .ant-list-item-action-split {
    display: none;
  }
  .ant-list-item-meta-description {
    opacity: 0.75;
  }

  .ant-btn {
    span {
      line-height: 18px;
      white-space: pre-wrap;
      word-wrap: break-word;
    }
    svg {
      min-width: 20px;
      min-height: 20px;
    }
  }

  .resp {
    p {
      margin: 0;
      text-align: left;
      max-width: 128px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }

  .action-btns {
    display: flex;
    justify-content: center;
    gap: 10px;
    .action-btn + .action-btn {
      margin-left: 8px;
      width: 48px;
    }
    .action-btn {
      font-size: 14px;
      font-weight: 500;
      border-radius: 24px;
      border: 1px solid var(--ghost);
      background-color: var(--ghost);
      svg {
        path {
          transition: stroke 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
        }
      }
      &:active,
      &:focus,
      &:hover {
        color: var(--gray-1);
        svg {
          path {
            stroke: var(--gray-1);
          }
        }
      }
    }
  }

  .ant-table-container table > thead > tr:first-child th:first-child {
    border-top-left-radius: 8px;
  }
  .ant-table-container table > thead > tr:first-child th:last-child {
    border-top-right-radius: 8px;
  }
  .ant-table-container table > tbody > tr:last-child td:first-child {
    border-bottom-left-radius: 8px;
  }
  .ant-table-container table > tbody > tr:last-child td:last-child {
    border-bottom-right-radius: 8px;
  }

  .ant-table-container table > tbody > tr td {
    border-left: 1px solid var(--ghost);
    &:last-child {
      border-right: 1px solid var(--ghost);
    }
  }
  .ant-table-selection-column {
    padding: 16px;
  }

  .ant-table-thead .ant-table-cell {
    background-color: var(--veloprime-bg-dark) !important;
    font-weight: 600;
    color: var(--white) !important;
    &:before {
      visibility: hidden;
    }
    &.ant-table-selection-column {
      .ant-table-selection {
        .ant-checkbox {
          .ant-checkbox-inner {
            border-color: var(--white);
            background-color: var(--white);
          }
          &.ant-checkbox-checked {
            .ant-checkbox-inner {
              border-color: var(--ant-primary-color);
              background-color: var(--ant-primary-color);
            }
          }
        }
      }
    }
  }

  // Sobrescrevendo estilos globais com maior especificidade
  .ant-table-wrapper .ant-table-thead > tr > th {
    background-color: var(--veloprime-bg-dark) !important;
    color: var(--white) !important;
  }

  // Estilos específicos para cada célula do cabeçalho
  .ant-table-thead .ant-table-cell,
  .ant-table-thead .ant-table-cell {
    background-color: var(--veloprime-bg-dark) !important;
    color: var(--white) !important;
  }

  // Estilos com máxima especificidade para sobrescrever tudo
  .ant-table-wrapper .ant-table .ant-table-thead > tr > th.ant-table-cell {
    background-color: var(--veloprime-bg-dark) !important;
    color: var(--white) !important;
  }

  // Estilos para o container da tabela
  .ant-table-container .ant-table-thead > tr > th {
    background-color: var(--veloprime-bg-dark) !important;
    color: var(--white) !important;
  }

  // Corrigindo o problema do tooltip que fica cinza no hover
  .ant-table-thead .ant-table-cell:hover {
    background-color: var(--veloprime-bg-dark) !important;
    color: var(--white) !important;
    
    .ant-table-column-title {
      color: var(--white) !important;
    }
    
    .ant-table-column-sorter {
      .ant-table-column-sorter-inner {
        .ant-table-column-sorter-up,
        .ant-table-column-sorter-down {
          color: var(--white) !important;
        }
      }
    }
  }

  // Estilos adicionais para garantir que o hover não mude a cor
  .ant-table-thead > tr:hover > th {
    background-color: var(--veloprime-bg-dark) !important;
    
    .ant-table-cell {
      background-color: var(--veloprime-bg-dark) !important;
      color: var(--white) !important;
    }
  }

  // Sobrescrevendo estilos globais do Ant Design com maior especificidade
  .ant-table-wrapper .ant-table-thead > tr > th:hover {
    background-color: var(--veloprime-bg-dark) !important;
    
    .ant-table-cell {
      background-color: var(--veloprime-bg-dark) !important;
      color: var(--white) !important;
    }
  }

  // Garantindo que as células do cabeçalho mantenham a cor no hover
  .ant-table-thead .ant-table-cell:hover,
  .ant-table-thead .ant-table-cell:focus,
  .ant-table-thead .ant-table-cell:active {
    background-color: var(--veloprime-bg-dark) !important;
    color: var(--white) !important;
  }

  // Garantindo que todos os ícones de ordenação tenham a cor correta
  .ant-table-thead .ant-table-cell {
    .ant-table-column-sorter {
      .ant-table-column-sorter-inner {
        .ant-table-column-sorter-up,
        .ant-table-column-sorter-down {
          color: var(--white) !important;
          
          &.active {
            color: var(--ant-primary-color) !important;
          }
        }
      }
    }
    
    // Estilização para o tooltip de ordenação
    .ant-table-column-title {
      color: var(--white) !important;
    }
  }

  // Adicionando estilos para melhorar o contraste das células da tabela
  .ant-table-tbody .ant-table-cell {
    color: var(--dark-1) !important;
    font-weight: 500;
    border-bottom: 1px solid var(--gray-1) !important;
  }

  // Estilização para hover das linhas da tabela
  .ant-table-tbody > tr:hover > td {
    background-color: var(--ghost-white) !important;
  }

  // Estilização global para tooltips
  .ant-tooltip {
    .ant-tooltip-inner {
      background-color: var(--veloprime-bg-dark) !important;
      color: var(--white) !important;
    }
    
    .ant-tooltip-arrow::before {
      background-color: var(--veloprime-bg-dark) !important;
    }
  }

  // Estilização específica para o input de busca
  .ant-input-affix-wrapper {
    border: 2px solid var(--light-gray) !important;
    background-color: var(--light-gray) !important;
    border-radius: 8px !important;
    transition: all 0.3s ease !important;
    height: 56px !important;
    
    &:hover {
      border-color: var(--ant-primary-color) !important;
    }
    
    &.ant-input-affix-wrapper-focused {
      border-color: var(--ant-primary-color) !important;
      box-shadow: 0 0 0 2px rgba(184, 134, 11, 0.2) !important;
    }
    
    .ant-input-prefix {
      color: var(--gray-2) !important;
      margin-right: 8px;
      padding: 0 12px !important;
      
      svg {
        fill: var(--gray-2) !important;
      }
    }
    
    .ant-input {
      height: 52px !important;
      background-color: transparent !important;
      border: none !important;
      color: var(--dark-1) !important;
      font-weight: 500;
      border-radius: 6px !important;
      
      &::placeholder {
        color: var(--gray-2) !important;
      }
      
      &:focus {
        box-shadow: none !important;
      }
    }
    
    // Estilização para o prefix quando focado
    &.ant-input-affix-wrapper-focused .ant-input-prefix {
      color: var(--ant-primary-color) !important;
      
      svg {
        fill: var(--ant-primary-color) !important;
      }
    }
  }

  // Estilos mais específicos para sobrescrever completamente os globais
  .ant-input-affix-wrapper.ant-input-affix-wrapper {
    border: 2px solid var(--light-gray) !important;
    background-color: var(--light-gray) !important;
    border-radius: 8px !important;
    height: 56px !important;
    
    &:hover {
      border-color: var(--ant-primary-color) !important;
      background-color: var(--light-gray) !important;
    }
    
    &.ant-input-affix-wrapper-focused {
      border-color: var(--ant-primary-color) !important;
      box-shadow: 0 0 0 2px rgba(184, 134, 11, 0.2) !important;
      background-color: var(--light-gray) !important;
    }
    
    .ant-input-prefix {
      padding: 0 12px !important;
      color: var(--gray-2) !important;
      
      svg {
        fill: var(--gray-2) !important;
      }
    }
    
    .ant-input {
      height: 52px !important;
      background-color: transparent !important;
      border: none !important;
      color: var(--dark-1) !important;
      font-weight: 500;
      border-radius: 6px !important;
      
      &::placeholder {
        color: var(--gray-2) !important;
      }
      
      &:focus {
        box-shadow: none !important;
      }
    }
    
    // Estilização para o prefix quando focado
    &.ant-input-affix-wrapper-focused .ant-input-prefix {
      color: var(--ant-primary-color) !important;
      
      svg {
        fill: var(--ant-primary-color) !important;
      }
    }
  }

  // Estilos com máxima especificidade para eliminar quadrado duplo
  .ant-input-affix-wrapper.ant-input-affix-wrapper.ant-input-affix-wrapper {
    &:hover {
      background-color: var(--light-gray) !important;
      border-color: var(--ant-primary-color) !important;
    }
    
    &.ant-input-affix-wrapper-focused {
      background-color: var(--light-gray) !important;
      border-color: var(--ant-primary-color) !important;
    }
  }

  // Estilos para o wrapper interno do input (elimina quadrado duplo)
  .ant-input-affix-wrapper .ant-input-prefix {
    background-color: transparent !important;
    border: none !important;
    box-shadow: none !important;
    
    &:hover {
      background-color: transparent !important;
      border: none !important;
      box-shadow: none !important;
    }
  }

  // Estilos para o input interno (elimina quadrado duplo)
  .ant-input-affix-wrapper .ant-input {
    background-color: transparent !important;
    border: none !important;
    box-shadow: none !important;
    
    &:hover {
      background-color: transparent !important;
      border: none !important;
      box-shadow: none !important;
    }
    
    &:focus {
      background-color: transparent !important;
      border: none !important;
      box-shadow: none !important;
    }
  }

  // Sobrescrevendo estilos globais do Ant Design que causam quadrado duplo
  .ant-input-affix-wrapper {
    &:hover {
      .ant-input-prefix {
        background-color: transparent !important;
        border: none !important;
        box-shadow: none !important;
      }
      
      .ant-input {
        background-color: transparent !important;
        border: none !important;
        box-shadow: none !important;
      }
    }
    
    &.ant-input-affix-wrapper-focused {
      .ant-input-prefix {
        background-color: transparent !important;
        border: none !important;
        box-shadow: none !important;
      }
      
      .ant-input {
        background-color: transparent !important;
        border: none !important;
        box-shadow: none !important;
      }
    }
  }

  @media only screen and (max-device-width: 812px) {
    padding: 32px 16px;
    border-radius: 0;
    box-shadow: none;

    .ant-list.ant-list-split {
      padding: 0 16px;
      font-size: 12px;

      .ant-list-item {
        padding: 16px 0;
      }

      .ant-list-item-action {
        flex-direction: column;
      }
    }

    .ant-table-content {
      overflow-y: auto;
    }
  }
`;

export const HiredTag = styled.div`
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  column-gap: 8px;
  padding: 4px 16px;
  border: none;
  font-size: 14px;
  font-weight: 500;
  color: var(--white);
  background-color: var(--dark-1);
`;

export const DownloadIcon = styled(GrDocumentDownload)`
  width: 16px;
  height: 16px;
  margin-left: 4px;
  cursor: pointer;
  path {
    stroke: var(--white);
  }
`;

export const DarfAutomaticoContainer = styled.div`
  height: 44px;
  display: flex;
  font-weight: 500;
  justify-content: flex-end;
  margin-top: 16px;
  align-items: center;
  color: var(--gray-3);

  .ant-switch {
    background-color: var(--ant-error-color);
    margin-right: 8px;
  }

  .ant-switch-checked {
    background-color: var(--ant-success-color);
  }

  .ant-switch-inner {
    position: relative;
    width: 16px;
    height: 16px;
  }
  .ant-switch-inner .anticon-loading {
    scale: 0.6;
    position: absolute;
    top: -4px;
    left: -4px;
  }

  @media only screen and (max-device-width: 812px) {
    margin: 0;
    padding: 0 16px;
  }
`;

export const DropdownButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--ant-gray-2);
  svg {
    margin-right: 8px;
    transform: translateY(-1px);
    font-size: 16px;
  }
`
